import { buildContractFileDownloadPath } from "./contractDetailsShared.mjs";

export const openContractFileDownload = async ({
  httpClient,
  browserWindow,
  contractId,
  file,
}) => {
  const downloadPath = buildContractFileDownloadPath(contractId, file?.id);
  const BlobConstructor = browserWindow?.Blob;
  if (!downloadPath || !httpClient || typeof BlobConstructor !== "function") return false;
  if (typeof browserWindow?.URL?.createObjectURL !== "function") return false;

  let objectUrl = null;
  let previewWindow = null;
  try {
    previewWindow = browserWindow.open("", "_blank");
    if (previewWindow) previewWindow.opener = null;
    const response = await httpClient.get(downloadPath, { responseType: "blob" });
    const blob = new BlobConstructor([response.data], {
      type: String(file?.mime_type || "").trim() || "application/octet-stream",
    });
    objectUrl = browserWindow.URL.createObjectURL(blob);
    if (!previewWindow) return false;
    previewWindow.location.replace(objectUrl);
    return true;
  } catch (_) {
    previewWindow?.close();
    return false;
  } finally {
    if (objectUrl) {
      browserWindow.setTimeout(() => browserWindow.URL.revokeObjectURL(objectUrl), 60000);
    }
  }
};
